import * as React from 'react'
import { Col, FormGroup, FormText, Input, InputGroup, Label, FormFeedback } from 'reactstrap'

import type { ColumnSize } from 'components/common/types'
import { ColumnSizes } from 'components/common/utils'

import styles from './BalanceOfPaymentsFormat.module.scss'

type InputGroupFormatWithCostsBadgeProps = {
  label: string | JSX.Element
  labelSize?: ColumnSize
  size?: ColumnSize
  placeholder?: string
  formText?: string | JSX.Element
  className?: string
  value?: string
  addonText: string
  maxLength?: number
  disabled?: boolean
  onChange: (value: string) => void
  validations?: Array<(s: string | undefined) => string>
  onValidate?: (b: boolean) => void
  backgroundColor?: string
  onFocus?: () => void
  onBlur?: () => void
}

type InputGroupFormatWithSalesBadgeProps = InputGroupFormatWithCostsBadgeProps

export const InputGroupFormatWithCostsBadge: React.FC<InputGroupFormatWithCostsBadgeProps> = ({
  label,
  placeholder,
  value,
  addonText,
  labelSize = ColumnSizes.short,
  size = ColumnSizes.large,
  className,
  maxLength,
  formText,
  disabled,
  onChange,
  validations,
  onValidate,
  onFocus,
  onBlur,
}) => {
  const [errorMessage, setErrorMessage] = React.useState<string | undefined>('')
  const invalid = React.useCallback(
    (inputValue: string | undefined) => validations?.find(validation => validation(inputValue))?.(inputValue),
    [validations]
  )

  React.useEffect(() => {
    setErrorMessage(invalid(value))
  }, [invalid, value])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement> | React.FocusEvent<HTMLInputElement>) => {
    onChange(e.target.value)
  }

  const id = React.useMemo(() => `id-${Math.random()}`, [])
  const style: React.CSSProperties = {
    textAlign: 'right',
  }

  // 直接onValidateを実行すると親のrender中に子コンポーネントから状態を変えることになりwarningが出る
  React.useEffect(() => onValidate?.(!errorMessage), [onValidate, value, errorMessage])
  return (
    <>
      <FormGroup row className="mb-0 position-relative">
        <Label for={id} md={labelSize}>
          {label}
        </Label>
        <Col md={size} className={className ? styles[className] : ''}>
          <InputGroup className="flex-nowrap">
            <Input
              id={id}
              style={style}
              value={value || ''}
              placeholder={placeholder}
              invalid={!!errorMessage}
              maxLength={maxLength}
              className={`form-control ${styles.inputPaddingLeft}`}
              disabled={disabled}
              onChange={e => onChange(e.target.value)}
              onBlur={onBlur ? () => onBlur() : handleChange}
              onFocus={() => onFocus?.()}
            />
            <span
              className={`position-absolute badge rounded-pill fw-normal font-small py-2 px-3 my-1 mx-2 ${styles.innerBadgeLabel} ${styles.badgeColorCosts}`}
            >
              費用
            </span>
            <span className="input-group-text rounded-end">{addonText}</span>
          </InputGroup>
          {errorMessage && (
            <FormFeedback className="d-block" hidden={!errorMessage}>
              {errorMessage}
            </FormFeedback>
          )}
          <FormText color="muted" hidden={!formText}>
            {formText}
          </FormText>
        </Col>
      </FormGroup>
    </>
  )
}

export const InputGroupFormatWithSalesBadge: React.FC<InputGroupFormatWithSalesBadgeProps> = ({
  label,
  placeholder,
  value,
  addonText,
  labelSize = ColumnSizes.short,
  size = ColumnSizes.large,
  className,
  maxLength,
  formText,
  disabled,
  onChange,
  validations,
  onValidate,
  onFocus,
  onBlur,
}) => {
  const [errorMessage, setErrorMessage] = React.useState<string | undefined>('')
  const invalid = React.useCallback(
    (inputValue: string | undefined) => validations?.find(validation => validation(inputValue))?.(inputValue),
    [validations]
  )

  React.useEffect(() => {
    setErrorMessage(invalid(value))
  }, [invalid, value])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement> | React.FocusEvent<HTMLInputElement>) => {
    onChange(e.target.value)
  }

  const id = React.useMemo(() => `id-${Math.random()}`, [])
  const style: React.CSSProperties = {
    textAlign: 'right',
  }

  // 直接onValidateを実行すると親のrender中に子コンポーネントから状態を変えることになりwarningが出る
  React.useEffect(() => onValidate?.(!errorMessage), [onValidate, value, errorMessage])
  return (
    <>
      <FormGroup row className="mb-0 position-relative">
        <Label for={id} md={labelSize}>
          {label}
        </Label>
        <Col md={size} className={className ? styles[className] : ''}>
          <InputGroup className="flex-nowrap">
            <Input
              id={id}
              style={style}
              value={value || ''}
              placeholder={placeholder}
              invalid={!!errorMessage}
              maxLength={maxLength}
              className={`form-control ${styles.inputPaddingLeft}`}
              disabled={disabled}
              onChange={e => onChange(e.target.value)}
              onBlur={onBlur ? () => onBlur() : handleChange}
              onFocus={() => onFocus?.()}
            />
            <span
              className={`position-absolute badge rounded-pill fw-normal font-small py-2 px-3 my-1 mx-2 ${styles.innerBadgeLabel} ${styles.badgeColorSales}`}
            >
              売上
            </span>
            <span className="input-group-text rounded-end">{addonText}</span>
          </InputGroup>
          {errorMessage && (
            <FormFeedback className="d-block" hidden={!errorMessage}>
              {errorMessage}
            </FormFeedback>
          )}
          <FormText color="muted" hidden={!formText}>
            {formText}
          </FormText>
        </Col>
      </FormGroup>
    </>
  )
}
